import * as AccordionPrimitive from '@radix-ui/react-accordion';

import { cn } from '@/utils/cn';

import { Value } from '../../types';
import { TriggerIndicator } from '../trigger-indicator';

type Props = Value & {
    index: number;
};

export const ValueCardMobile = ({
    classNameColor,
    description,
    icon,
    name,
}: Props) => (
    <AccordionPrimitive.Item
        value={`accordion-item-${name}`}
        key={name}
        className={cn(
            `
              group flex w-full flex-1 cursor-pointer flex-col rounded-[40px]
              pb-10 pl-4 pr-5 pt-8
            `,
            classNameColor,
        )}
    >
        <AccordionPrimitive.Trigger
            className={`[&[data-state=open]_[data-indicator]]:rotate-45`}
        >
            <div className="relative flex justify-between">
                {icon}

                <div className="flex">
                    <div
                        className={`
                          absolute -mt-12 flex-1 origin-bottom-left rotate-90
                          rounded-full border p-2 text-2xl font-medium
                          text-primary-black
                        `}
                    >
                        {name}
                    </div>
                    <div />
                    <TriggerIndicator
                        data-indicator
                        className={cn('transition-transform duration-150')}
                    />
                </div>
            </div>
            <AccordionPrimitive.Content
                className={`
                  overflow-hidden text-left

                  data-[state=closed]:animate-accordion-up

                  data-[state=open]:animate-accordion-down
                `}
            >
                <div className={`mt-10 flex flex-col gap-4 text-primary-black`}>
                    {description}
                </div>
            </AccordionPrimitive.Content>
        </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Item>
);
